import NUS_LOGO from '../img/logos/nus_logo.jpg';
import AZEN_LOGO from '../img/logos/Azendian.png';
import BM_LOGO from '../img/logos/botmind_logo.png';

/**
 * Latest experience at the front of the array
 */
const workExperience = [
  {
    year: 'Feb 2025 - Aug 2025',
    logo: BM_LOGO,
    title: 'Robotics Engineer Intern',
    subTitle: 'Botmind Pte Ltd',
    text: `Working as a Robotics engineer in Botmind has allowed me to apply my knowledge in robotics and software engineering.
    I am currently working on a project that involves developing a robotic system for autoionization,
    focusing on computer vision and machine learning. I learned many new skills such as Nodered, scripting, computer vision as well as ROS2.`,
  },
  {
    year: 'May 2022 - Sep 2022',
    logo: AZEN_LOGO,
    title: 'Frontend Developer Intern',
    subTitle: 'Azendian Solutions Pte Ltd',
    text: `This internship allowed me to put my React JS, Html, CSS and PostgreSQl skills to good use. I had the chance to design, create and implement 
    2 full modules during my time here. This allowed me to gain valuable insights on the developmental process and workflow of 
    a tech company. My problem solving skills were put to the test as we created 15+ different individual fullstack components and scripts.`,
  },
  {
    year: 'Aug 2022 - May 2023',
    logo: NUS_LOGO,
    title: 'CS2040 (Data Structures and Algorithms) Lab Teaching Assistant',
    subTitle: 'National University of Singapore',
    text: `In this role, my responsibilities includes creating slides to deliver Module content to a class of 20 students, 
    answering queries and marking assignments. We work closely with the professors to ensure that the labs covers the scope of the 
    lecture and bridge the theory taught with lecture with practical applications.`,
  },
  {
    year: 'Jan 2023 - May 2023',
    title: 'CS1010E (Programming Methodology) Tutorial Teaching Assistant',
    subTitle: 'National University of Singapore',
    logo: NUS_LOGO,
    text: `In this role, my responsibilities include teaching a class of 20 students the basics of Python, 
    answering queries and marking assignments.`,
  },
];

export default workExperience;
